import { t } from 'src/translations'
import React from 'react'
import Image from 'shared/components/common/Image'

const ToastAccountValueProp = () => {
  return (
    <div className='accountSection toastAccountValueProp' tabIndex={0}>
      <div className='sectionTitle'>
        <Image src='icons/toast-logo-orange-with-text.svg' alt='Toast logo' />
      </div>
      <div className='valuePropContent'>
        <div className='heading'>{t('toast-account-value-prop.heading')}</div>
        <div className='description'>
          {t('toast-account-value-prop.description')}
        </div>
      </div>
    </div>
  )
}

export default ToastAccountValueProp
